import styled from 'styled-components';

import { Link as LinkDefault } from '../../Link';

export const Wrapper = styled.div`
  font-family: 'Poppins', sans-serif;
`;

export const Link = styled(LinkDefault)`
  font-family: 'Poppins', sans-serif !important;
`;
